import { AccessType } from "@components/Exclusives/FeedAccess/AccessCarousel/types";
import { ImageSourcePropType } from "react-native";

type BackgroundImages = {
  [key in AccessType]: ImageSourcePropType;
};

const backgroundImages: BackgroundImages = {
  post: require("@assets/images/carousel/bg-post.webp"),
  music: require("@assets/images/carousel/bg-music.webp"),
  video: require("@assets/images/carousel/bg-video.webp"),
  experience: require("@assets/images/carousel/bg-experience.webp"),
  chat: require("@assets/images/carousel/bg-chat.webp"),
  event: require("@assets/images/carousel/bg-event.webp"),
  merch: require("@assets/images/carousel/bg-merch.webp"),
  top: require("@assets/images/carousel/bg-top.webp"),
  dj_set: require("@assets/images/carousel/bg-top.webp"),
};

export default backgroundImages;
